import z from "zod";
import { SessionLineDto } from "../api";

export function RequiredNonEmptyString(emptyVal: string, missingVal?: string){
    return z.string({
        error: (ctx) => { return !ctx.input ? (missingVal ?? emptyVal) : void(0); }
    }).trim().nonempty(emptyVal)
};

export function RequiredFieldsNonEmptyString(emptyVal: string, missingVal?: string) {

};

export function isSessionLineDto(line: any): line is SessionLineDto {
    return line.$type === "SessionLineDto";
}